import { render, staticRenderFns } from "./ArchivedRequestContractorCardNew.vue?vue&type=template&id=0f29de22&scoped=true"
import script from "./ArchivedRequestContractorCardNew.vue?vue&type=script&lang=ts"
export * from "./ArchivedRequestContractorCardNew.vue?vue&type=script&lang=ts"
import style0 from "./ArchivedRequestContractorCardNew.vue?vue&type=style&index=0&id=0f29de22&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f29de22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f29de22')) {
      api.createRecord('0f29de22', component.options)
    } else {
      api.reload('0f29de22', component.options)
    }
    module.hot.accept("./ArchivedRequestContractorCardNew.vue?vue&type=template&id=0f29de22&scoped=true", function () {
      api.rerender('0f29de22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/onboarding/ArchivedRequestContractorCardNew.vue"
export default component.exports